module.exports = __webpack_public_path__ + "files/0667e40d9c3a251ec32b557b23e1b2fb.png";